var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 68,
    viewBox: "0 0 71 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.143 15.125C20.143 13.4311 21.5156 12.0625 23.2145 12.0625H46.2502C47.5171 12.0625 48.6497 12.8377 49.1105 14.0148C49.5712 15.192 49.2544 16.5318 48.3234 17.3836L35.7209 28.9062H37.8038C45.012 28.9062 50.8573 34.7346 50.8573 41.9219C50.8573 49.1092 45.012 54.9375 37.8038 54.9375H30.2596C26.1899 54.9375 22.4658 52.6406 20.6421 49.0135L20.4598 48.6498C19.7015 47.1377 20.3158 45.3002 21.8323 44.5441C23.3488 43.7881 25.1917 44.4006 25.95 45.9127L26.1323 46.2764C26.9098 47.8363 28.5127 48.8125 30.25 48.8125H37.8038C41.6238 48.8125 44.7145 45.7309 44.7145 41.9219C44.7145 38.1129 41.6238 35.0312 37.8038 35.0312H27.8216C26.5546 35.0312 25.4221 34.2561 24.9613 33.0789C24.5006 31.9018 24.8174 30.5619 25.7484 29.7102L38.3509 18.1875H23.2145C21.5156 18.1875 20.143 16.8189 20.143 15.125Z",
    fill: "#EE7733"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeIcon);
export default __webpack_public_path__ + "static/media/three-icon.99e862aa679524c252ed67633d434e7d.svg";
export { ForwardRef as ReactComponent };